export default {
  "privacy": {
    "heroTitle": "Privacy Policy",
    "lastUpdated": "Last updated: August 3, 2026",
    "sections": [
      {
        "title": "1. Introduction",
        "paragraphs": [
          "IS TELECOM (hereinafter \"we\", \"our\" or \"IS TELECOM\") is committed to protecting the privacy and personal data of its users, customers and partners. This Privacy Policy explains how we collect, use, store and protect your personal data when you use our website is-telecom.co (hereinafter \"the Site\") or when you interact with us.",
          "By using the Site or providing us with your personal data, you accept the practices described in this Privacy Policy. If you do not accept this policy, please do not use the Site."
        ]
      },
      {
        "title": "2. Data Controller",
        "paragraphs": [
          "The data controller for personal data collected via the Site is IS TELECOM, located in Cotonou, Benin.",
          "Phone: +229 01 95 89 27 55 — Email: contact@is-telecom.co"
        ]
      },
      {
        "title": "3. Data Collected",
        "paragraphs": ["We collect the following categories of personal data:"],
        "list": [
          "Identification data: first name, last name, company name",
          "Contact data: email address, phone number, postal address",
          "Project-related data: project type, location, estimated budget, description of needs",
          "Browsing data: IP address, browser type, pages visited, visit duration"
        ]
      },
      {
        "title": "4. Purposes of Processing",
        "paragraphs": ["Your personal data is collected and processed for the following purposes:"],
        "list": [
          "Responding to requests: processing your quote, contact and information requests",
          "Customer relationship management: tracking your projects, preparing quotes, managing contracts",
          "Communication: informing you about our services, news and offers (with your consent)",
          "Site improvement: analyzing Site usage to improve content and navigation",
          "Legal obligations: complying with our legal, regulatory and tax obligations"
        ]
      },
      {
        "title": "5. Legal Basis for Processing",
        "paragraphs": ["The processing of your personal data is based on one of the following legal bases:"],
        "list": [
          "Contract performance: when processing is necessary for the performance of a contract",
          "Consent: when you have given your explicit consent",
          "Legitimate interest: when processing is necessary for IS TELECOM's legitimate interests",
          "Legal obligation: when processing is necessary to comply with a legal obligation"
        ]
      },
      {
        "title": "6. Retention Period",
        "paragraphs": ["Your personal data is retained for the strictly necessary period:"],
        "list": [
          "Contact/quote requests: 3 years from last contact",
          "Customer and contract data: 10 years from end of contract",
          "Newsletter and marketing: until you withdraw your consent",
          "Browsing data (cookies): maximum 13 months"
        ]
      },
      {
        "title": "7. Data Sharing",
        "paragraphs": [
          "IS TELECOM does not sell or rent your personal data to third parties. Your data may however be shared with service providers (web host, analytics tools, email services), competent authorities when required by law, or business partners only with your prior consent."
        ]
      },
      {
        "title": "8. Data Security",
        "paragraphs": [
          "IS TELECOM implements appropriate technical and organizational measures to protect your personal data: data encryption in transit (HTTPS/TLS), role-based restricted access, employee training, regular monitoring and auditing."
        ]
      },
      {
        "title": "9. Your Rights",
        "paragraphs": [
          "In accordance with applicable law, you have the following rights: right of access, right of rectification, right to erasure, right to restriction, right to object, right to data portability."
        ]
      },
      {
        "title": "10. Cookies and Similar Technologies",
        "paragraphs": [
          "The Site uses essential, performance, functionality and targeting cookies. You can manage your preferences through your browser settings."
        ]
      },
      {
        "title": "11. International Transfers",
        "paragraphs": [
          "IS TELECOM is present in 6 African countries. Your data may be transferred and processed in countries other than where you reside, with appropriate safeguards in place to protect your data."
        ]
      },
      {
        "title": "12. Policy Changes",
        "paragraphs": [
          "IS TELECOM reserves the right to modify this Privacy Policy at any time. Any modification will be published on this page with the update date."
        ]
      },
      {
        "title": "13. Contact",
        "paragraphs": [
          "For any questions regarding this Privacy Policy or to exercise your rights, contact us: IS TELECOM — Data Protection Officer, Cotonou, Benin. Phone: +229 01 95 89 27 55. Email: contact@is-telecom.co"
        ]
      }
    ]
  }
};